import React from 'react';
import {connect} from 'react-redux';
import {Grid, Typography} from 'material-ui';

class Welcome extends React.Component {
    render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="subheading">Welcome, </Typography>
                    <Typography variant="subheading">{this.props.userName}</Typography>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    userName: state.auth.user.name,
});

export default connect(mapStateToProps, {})((Welcome));


// WEBPACK FOOTER //
// ./src/containers/dashboard/welcome.js